import { render } from "./AdvertisingLicense.vue?vue&type=template&id=98a16fc2"
import script from "./AdvertisingLicense.vue?vue&type=script&lang=js"
export * from "./AdvertisingLicense.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__